import './hijackJump';
import { setupRemoteApps } from './injected-module-app';

console.log('我发版到了准线上');

setupRemoteApps().then(() => {
  import('./bootstrap.js');
});
